import React from 'react'
import { BellIcon } from '../../../Icons/BellIcon'

const BeforePaymentMultipartyBanner = () => {
  return (
    <div className="purpleHeader">
      <div className="outerouter">
        <BellIcon />
        <div className="myStuff">
          <span className="stuffH2 ">
            We&apos;ve updated the Express Checkout track seller onboarding{' '}
            <a href="#link-expcheckoutresp">sample response</a>.
          </span>
        </div>
      </div>
    </div>
  )
}

export default BeforePaymentMultipartyBanner
